"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_global_FontSize_sm_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_global_FontSize_sm"));
const chart_global_FontSize_2xl_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_global_FontSize_2xl"));
const chart_donut_label_subtitle_Fill_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_label_subtitle_Fill"));
const chart_donut_label_subtitle_position_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_label_subtitle_position"));
// Donut styles
exports.DonutStyles = {
    label: {
        subTitle: {
            // Victory props only
            fill: chart_donut_label_subtitle_Fill_1.default.value,
            fontSize: chart_global_FontSize_sm_1.default.value
        },
        subTitlePosition: chart_donut_label_subtitle_position_1.default.value,
        title: {
            // Victory props only
            fontSize: chart_global_FontSize_2xl_1.default.value
        }
    }
};
//# sourceMappingURL=donut-styles.js.map